import React from 'react'
import TeacherSignupProvider from './state'
import TeacherSignupView from './view'
import SuiThemeProvider from 'baseStyles/AppMediaProvider'
import './styles.scss'
import { SuiTurnstileProvider, TurnstileEnabledFeature } from 'schoolUiComponents/SuiTurnstile'
import { HoneyPotInput } from 'schoolUiComponents/HoneyPotInput'
import { initGlobalCachePrevention } from '../utils/preventBrowserCache';

const TeacherSignup: React.FC = () => {
    return (
        <HoneyPotInput>
            <SuiThemeProvider>
                <SuiTurnstileProvider dontShowSpinner userType='Teacher' action='TEACHER_SIGNUP_FORM' featureName={TurnstileEnabledFeature.parent_and_teacher_signup}>
                    <TeacherSignupProvider>
                        <TeacherSignupView />
                    </TeacherSignupProvider>
                </SuiTurnstileProvider>
            </SuiThemeProvider>
        </HoneyPotInput>
    )
}

// Initialize global cache prevention
initGlobalCachePrevention();

const container = document.getElementById('teacher-signup-container-wrap');

if (container) {
    // @ts-ignore
    import('react-dom/client').then(({ createRoot }) => {
        const root = createRoot(container);
        root.render(<TeacherSignup />);
    })
}

export default TeacherSignup;
